import { useEffect } from 'react'
import { useSnackbar } from 'notistack'
import { useSelector } from 'react-redux'

export default function Snackbar() {
  const { enqueueSnackbar, closeSnackbar } = useSnackbar()

  const { openMessage, messageConfig } = useSelector((state) => state.message)

  useEffect(() => {
    if (openMessage && messageConfig && messageConfig.message) {
      enqueueSnackbar(messageConfig.message, {
        variant: messageConfig.type,
        autoHideDuration: messageConfig.autoHide ? 5000 : null,
      })
    }
  }, [openMessage, messageConfig, enqueueSnackbar, closeSnackbar])

  return ''
}
